export default {"src":"/_next/static/media/down_chevron.58b89067.svg","height":7,"width":10,"blurWidth":0,"blurHeight":0};